export default "__VITE_ASSET__c7824522__"